export default "__VITE_ASSET__DYyuzn4J__"